import { DIPLOMATEN_CODE } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';
import { VertragsoptionenVHV } from '../../../store/model/vertragsoptionen.model';

export const selectVertragsoptionen = (state: IAppState): VertragsoptionenVHV =>
  state.vertragsoptionen;
export const selectVertragslaufzeit = (state: IAppState): string =>
  String(state.vertragsoptionen.vertragslaufzeit);
export const selectIsDiplomatengeschaeft = (state: IAppState): boolean =>
  state.vertragsoptionen.selectedKooperation === DIPLOMATEN_CODE;
export const selectIsNeugeschaeft = (state: IAppState): boolean =>
  !state.vertragsoptionen.vorvertragsNummern ||
  state.vertragsoptionen.vorvertragsNummern.length === 0;

export const selectZahlweise = (state: IAppState): string =>
  state.vertragsoptionen.zahlungsweise.toLowerCase();

export type SelectVertragsoptionenReturnType = ReturnType<typeof selectVertragsoptionen>;
